import React from 'react';
import PropTypes from 'prop-types';

const ListItemContentTitle = (props) => {
  const {
    box,
    boxIdClass,
    title,
  } = props;

  return (
    <div
      className="help-side-bar-list-item help-side-bar-list-item-title"
      key={`title-${title}`}
    >
      <span className={boxIdClass}>{box}. </span>
      {title}
    </div>
  );
};

ListItemContentTitle.defaultProps = {
  boxIdClass: '',
};

ListItemContentTitle.propTypes = {
  box: PropTypes.string.isRequired,
  boxIdClass: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default ListItemContentTitle;



// WEBPACK FOOTER //
// ./src-react/VisualStatic/components/ListItemContentTitle.jsx